import React from 'react';
import { Redirect } from 'react-router';
import { generatePath, Route, Switch } from 'react-router-dom';
import { DATE_FORMAT_URL } from '../../../../data/constants/datetime';
import { useEvent } from '../../../../data/hooks/eventHooks';
import { useProgramSession } from '../../../../data/hooks/schedule/useProgramSession';
import { eventMomentFactory } from '../../../../data/misc/eventMomentFactory';
import RelativeRedirect from '../../../elements/RelativeRedirect';
import EventScheduleItemParticipantsScreen from '../../../screens/EventSchedule/EventScheduleItemParticipantsScreen/EventScheduleItemParticipantsScreen';
import EventScheduleItemScreen from '../../../screens/EventSchedule/EventScheduleItemScreen/EventScheduleItemScreen';
import EventSpeakerProfile from '../../../screens/EventSpeakers/EventSpeakerProfile';
import LiveVotingBase from '../../../screens/LiveVoting/LiveVotingBase';
import InviteToMeetingScreen from '../../../screens/Meetings/InviteToMeetingScreen';
import directoryRoutes from '../../directoryRoutes';
import participantsRoutes from '../../participantsRoutes';

function ScheduleItemRoutes(props) {
    const { match } = props,
        { eventId, date, itemId } = match.params,
        event = useEvent(eventId),
        session = useProgramSession(eventId, itemId),
        sessionDate = eventMomentFactory(event, session?.start_local).format(DATE_FORMAT_URL);

    if (!event) return <RelativeRedirect to=".." />;
    if (!session) {
        // console.log('Session not found: ', eventId, itemId);
        return <RelativeRedirect to=".." />;
    }
    if (date && date !== sessionDate) {
        // console.log('Session date mismatch: ', sessionDate, date);
        return (
            <Redirect
                to={generatePath(match.path, {
                    ...match.params,
                    date: sessionDate,
                })}
            />
        );
    }

    return (
        <Switch>
            <Route path={`${props.match.path}/content/:path+`} component={directoryRoutes} />
            <Route path={`${props.match.path}/speakers/:speakerId`} exact component={EventSpeakerProfile} />
            <Route path={`${props.match.path}/speakers/:speakerId/invite`} exact component={InviteToMeetingScreen} />
            <Route path={`${props.match.path}/participants`} exact component={EventScheduleItemParticipantsScreen} />
            <Route path={`${props.match.path}/participants`} component={participantsRoutes} />
            <Route path={`${props.match.path}/livevoting/:liveVotingId`} exact component={LiveVotingBase} />
            <Route path={`${props.match.path}/invite`} exact component={InviteToMeetingScreen} />
            <Route path={`${props.match.path}`} exact component={EventScheduleItemScreen} />
            <Redirect to={`${props.match.path}`} />
        </Switch>
    );
}

export default ScheduleItemRoutes;
